import React from 'react';
import { useTranslation } from 'react-i18next';
import { TooltipHost, Icon, TextField } from 'office-ui-fabric-react';
import {
  getValidMail,
  getValidLink,
  checkMultipleValidators,
  validPhoneNumber,
  formatPhoneNumber,
} from '../../../../../utilities/validContactInformation';

import { getAttr } from '../../../../../features/helpers/apiHelpers';

const textfieldStyles = {
  root: { padding: '20px 0' },
  subComponentStyles: {
    label: {
      root: {
        fontSize: '14',
        fontWeight: '500',
        color: '#333333',
      },
    },
  },
};

const MetaDataContactInformation = ({
  updateHearingModelAttribute,
  hearingModel,
  showErrors,
}) => {
  const { t: translator } = useTranslation();

  const onChangeContactPersonNameCallback = (_, value) =>
    updateHearingModelAttribute('contactPersonName', value);
  const onChangeContactDepartmentNameCallback = (_, value) =>
    updateHearingModelAttribute('contactPersonDepartmentName', value);
  const onChangeContactPersonEmailCallback = (_, value) =>
    updateHearingModelAttribute('contactPersonEmail', value);
  const onChangeContactPhoneNumberCallback = (_, value) =>
    updateHearingModelAttribute(
      'contactPersonPhoneNumber',
      formatPhoneNumber(value),
    );

  const getLabelWithTooltip = (labelText, tooltipText) => (
    <div className="create-hearing-title-with-icon">
      <span>{labelText}</span>
      <TooltipHost content={tooltipText}>
        <Icon iconName="Info" styles={iconStyles} />
      </TooltipHost>
    </div>
  );

  return (
    <div>
      <br />
      <hr className="create-hearing-header-hr" />
      <div className="create-hearing-sub-header">
        <h3>{translator('global.contactInformation')}</h3>
        <TooltipHost
          content={translator('pages.createHearing.contactInformationTooltip')}
        >
          <Icon iconName="Info" />
        </TooltipHost>
      </div>
      <div id="contact-information-info">
        <TextField
          label={translator('pages.createHearing.contactInformationPerson')}
          placeholder={translator(
            'pages.createHearing.contactInformationPersonPlaceholder',
          )}
          onChange={onChangeContactPersonNameCallback}
          value={getAttr(hearingModel, 'contactPersonName')}
          styles={textfieldStyles}
        />
        <TextField
          label={getLabelWithTooltip(
            translator('hearingProperties.departmentName'),
            translator(
              'pages.createHearing.contactInformationDepartmentTooltip',
            ),
          )}
          placeholder={translator(
            'pages.createHearing.contactInformationDepartmentPlaceholder',
          )}
          onChange={onChangeContactDepartmentNameCallback}
          value={getAttr(hearingModel, 'contactPersonDepartmentName')}
          styles={textfieldStyles}
          errorMessage={
            showErrors && !getAttr(hearingModel, 'contactPersonDepartmentName')
              ? translator('global.validationError')
              : null
          }
        />
        <TextField
          label={getLabelWithTooltip(
            translator('hearingProperties.email'),
            translator('pages.createHearing.contactInformationEmailTooltip'),
          )}
          type="url"
          placeholder={translator(
            'pages.createHearing.contactInformationEmailPlaceholder',
          )}
          onChange={onChangeContactPersonEmailCallback}
          value={getAttr(hearingModel, 'contactPersonEmail')}
          styles={textfieldStyles}
          errorMessage={
            showErrors &&
            !checkMultipleValidators(false, [getValidMail, getValidLink])(
              getAttr(hearingModel, 'contactPersonEmail'),
            )
              ? translator('global.validationError')
              : null
          }
        />
        <TextField
          label={translator('pages.createHearing.contactInformationTelephone')}
          type="tel"
          placeholder={translator(
            'pages.createHearing.contactInformationTelephonePlaceholder',
          )}
          onChange={onChangeContactPhoneNumberCallback}
          value={getAttr(hearingModel, 'contactPersonPhoneNumber')}
          styles={textfieldStyles}
          errorMessage={
            showErrors &&
            !validPhoneNumber(true)(
              getAttr(hearingModel, 'contactPersonPhoneNumber'),
            )
              ? translator('global.validationError')
              : null
          }
        />
        {/* <MaskedTextField // A regular textfield is used instead to easily allow for optional phone-numbers. 
        This code is kept for reference for when data driven contactInformation logic will be implemented.
          label={translator('hearingProperties.telephone')}
          mask={'(+45) 9999-9999'}
          onChange={onChangeContactPhoneNumberCallback}
          value={getPhoneNumber(
            getAttr(hearingModel, 'contactPersonPhoneNumber'),
          )}
          ref={maskedTextRef}
          styles={textfieldStyles}
          errorMessage={
            showErrors &&
            !validPhoneNumber(getAttr(hearingModel, 'contactPersonPhoneNumber'))
              ? translator('global.requiredField')
              : null
          }
        /> */}
      </div>
      <br />
    </div>
  );
};

const iconStyles = {
  root: {
    paddingLeft: '5px',
  },
};

export { MetaDataContactInformation };
